import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@reducers/index';
import { setOpenPopup } from '@reducers/account/teamSlice';

const TeamList = () => {
  const dispatch = useDispatch<AppDispatch>();

  const onClickHandler = useCallback(() => {
    dispatch(setOpenPopup({ isOpen: true }));
  }, [dispatch, setOpenPopup]);

  return (
    <>
      <h3 className="t-manager-stit">All Team</h3>
      <div className="t-manager-btn">
        <button type="button" className="btn pri" onClick={onClickHandler}>
          Create Team
        </button>
      </div>
    </>
  );
};

export default TeamList;
